import SashiDo from 'lib/SashiDo';
import AccountManager from 'lib/AccountManager';
import ParseApp from 'lib/ParseApp';

let appsStore = [];

const AppsManager = {
  clearAppsStore() {
    appsStore = [];
  },

  addApp(raw) {
    const app = new ParseApp(raw);
    appsStore.push(app);
    this.sort();
    return app;
  },

  sort() {
    appsStore.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  },

  apps() {
    return appsStore;
  },

  appsStoreUpdateApp(app) {
    const appIndex = appsStore.findIndex((r) => {
      return r.id === app.objectId;
    });

    if (appIndex >= 0) {
      const newParseApp = new ParseApp(app);
      appsStore[appIndex] = newParseApp;
      return appsStore[appIndex];
    } else {
      return this.addApp(app);
    }

  },

  findAppBySlug(slug) {
    const apps = this.apps();
    for (let i = apps.length; i--;) { // eslint-disable-line
      if (apps[i].slug === slug) {
        return apps[i];
      }
    }
    return null;
  },

  create(data) {
    const promise = Promise.resolve();

    if (!data.name) {
      return Promise.reject({ message: 'Please enter a name for your application' });
    }

    if (!data.region) {
      return Promise.reject({ message: 'Please choose a region for your application' });
    }

    return promise.then(() => {
      return SashiDo.fastAppCreate(data);
    })
      .then(({ data }) => {
        const currentApp = this.addApp(data, true);
        return Promise.resolve({ app: currentApp });
      });
  },

  deleteApp(password, appName, appId) {
    return SashiDo.deleteApp({ password, appName, appObjectId: appId }).then(() => {
      for (let i = 0; i < appsStore.length; i++) {
        if (appsStore[i].name.toLocaleLowerCase() === appName.toLocaleLowerCase()) {
          appsStore.splice(i, 1);
          return;
        }
      }
    });
  },

  getAppClassesClount(app) {
    return SashiDo.getAppClassesClount({
      serverURL: app.serverURL,
      applicationId: app.applicationId,
      javascriptKey: app.javascriptKey,
      masterKey: app.masterKey,
    })
      .then(({ users, installations, serverInfo }) => {
        app.users = users || 0;
        app.installations = installations || 0;
        if (serverInfo) {
          app.serverInfo = serverInfo;
        }

        // this.appsStoreUpdateApp(app);
        return app;
      });
  },

  changeAppIcon({ id, icon }) {
    SashiDo.changeAppIcon({ id, icon }).then(({ id, url }) => {
      for (let i = 0; i < appsStore.length; i++) {
        if (appsStore[i].id === id) {
          appsStore[i].icon = url;
          return;
        }
      }
    });
  },

  async stats(apps) {
    return AccountManager.currentUser().then(async ({ currentUser }) => {
      if (!apps) {
        apps = {};

        AppsManager.apps().filter((i) => {
          return (i.user && i.user.objectId) && i.user.objectId === currentUser.id;
        }).map((item) => {
          if (item.id) {
            apps[item.id] = { createdAt: item.createdAt.getTime() };
          }
          return null;
        });
      }

      const result = await SashiDo.getUserAppsStats({ apps });

      // if (result && result.length > 0) {
      //   return SashiDo.getUserAppsStats({ apps });
      // }

      return result;
    });
  },
};

export default AppsManager;
